import React, { useMemo, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import ReactPlaceholder from 'react-placeholder/lib'
import { useParams } from 'react-router-dom'
import Controllers from '../../Api/Controllers'
import parse from 'html-react-parser'
import Helpers from '../../Components/Helpers/Helpers'
import { SurfaceCard } from '../../Components/Ui'
import { FormCustom, TextArea } from '../../Components/Form/Form'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import CommentNoti from './CommentNoti'

const avatarFallback = (e) => {
    e.currentTarget.style.display = 'none'
    if (e.currentTarget.nextSibling) e.currentTarget.nextSibling.style.display = 'inline-flex'
}

const btnPrimary = {
    borderRadius: 12,
    fontWeight: 700,
    minHeight: 42,
    padding: '0 18px',
    background: '#201030',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8
}

const NotiBlog = () => {
    const [noti, setNoti] = useState({})
    const [ready, setReady] = useState(false)
    const [readyComments, setReadyComments] = useState(false)
    const [reloadComments, setReloadComments] = useState(true)
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [row, setRow] = useState({
        p_id_noti: '',
        p_description_comment: ''
    })

    const store = useSelector(res => res)
    const [comments, setComments] = useState([])

    const { tokenNoti } = useParams()

    useEffect(() => {
        setReady(false)
        Controllers.noti.get_noti_token({
            p_token_noti: tokenNoti
        }).then(res => {
            setRow({ ...row, p_id_noti: res.data?.id_noti })
            setNoti(res.data)
            setReady(true)
        })
    }, [tokenNoti])

    useEffect(() => {
        setReadyComments(true)
        Controllers.comment.get_comment_noti({
            p_id_noti: tokenNoti
        }).then(res => {
            setComments(res.data)
            setReloadComments(false)
            setReadyComments(true)
        })
    }, [tokenNoti, reloadComments])

    const handleSubmitComment = ({ data }) => {
        setLoadSubmit(true)
        Controllers.comment.comment_noti_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            setRow({ ...row, p_description_comment: '' })
            setReloadComments(true)
            setLoadSubmit(false)
        })
    }

    const qtyComments = useMemo(() => {
        let qty = comments.length

        comments.forEach(c => {
            qty += parseInt(c.comments_child.length)
        })
        return qty
    }, [comments])

    return (
        <ReactPlaceholder ready={ready} showLoadingAnimation rows={15}>
            {noti?.name_noti ? <>
                <div style={{ padding: '8px 4px 16px' }}>
                    <h2 style={{ margin: '0 0 12px', fontSize: '1.35rem', fontWeight: 800, color: '#201030' }}>
                        {noti.name_noti}
                    </h2>
                    {noti.file_images ? (
                        <img
                            src={Helpers.config.resourcesUrl({ url: noti.file_images })}
                            alt=""
                            style={{ width: '100%', maxHeight: 360, objectFit: 'cover', borderRadius: 16, marginBottom: 16 }}
                        />
                    ) : null}
                    <div className="content_article_preview" style={{ color: '#374151', fontSize: '0.95rem', lineHeight: 1.6 }}>
                        {parse(`${noti.content_noti}`)}
                    </div>
                </div>

                <ReactPlaceholder className="mb-2" ready={readyComments} showLoadingAnimation rows={1}>
                    <h3 style={{ margin: '8px 4px 16px', fontSize: '1.05rem', fontWeight: 800, color: '#201030' }}>
                        {qtyComments} Comentarios
                    </h3>
                </ReactPlaceholder>

                <div className="form-row">
                    <div className="col-12 col-lg-4 mb-3">
                        <SurfaceCard title="Tu comentario">
                            <div className="d-flex align-items-center mb-3" style={{ gap: 10 }}>
                                <img
                                    src={store.session.file_photo_user}
                                    alt=""
                                    width="36"
                                    height="36"
                                    style={{ borderRadius: 999, objectFit: 'cover' }}
                                    onError={avatarFallback}
                                />
                                <span style={{ fontWeight: 600, color: '#201030', fontSize: '0.88rem' }}>
                                    {store.session.full_name || 'Tú'}
                                </span>
                            </div>
                            <FormCustom viewSubmit={false} dataSubmit={row} onSubmit={handleSubmitComment}>
                                <TextArea
                                    text="Escribe tu comentario"
                                    classNameParent="col-12"
                                    rows="5"
                                    required
                                    value={row.p_description_comment}
                                    onChange={e => setRow({ ...row, p_description_comment: e.currentTarget.value })}
                                />
                                <div className="col-12 mt-3">
                                    <button type="submit" style={btnPrimary}>
                                        {loadSubmit
                                            ? <i className="fa fa-circle-notch fa-spin" />
                                            : <><i className="fa fa-paper-plane" />Enviar</>}
                                    </button>
                                </div>
                            </FormCustom>
                        </SurfaceCard>
                    </div>
                    <div className="col-12 col-lg-8">
                        <ReactPlaceholder className="mb-2" ready={readyComments} showLoadingAnimation rows={15}>
                            {comments.length === 0 ? (
                                <div className="alert alert-warning mb-0" style={{ borderRadius: 14 }}>
                                    <strong>¡Sé el primero!</strong> Deja tu comentario.
                                </div>
                            ) : (
                                React.Children.toArray(comments.map(c => (
                                    <CommentNoti comment={c} onSuccess={() => setReloadComments(true)} />
                                )))
                            )}
                        </ReactPlaceholder>
                    </div>
                </div>
            </> : <>
                <div className="alert alert-warning" style={{ borderRadius: 14 }}>
                    <strong>¡Lo sentimos!</strong> No se ha encontrado información.
                </div>
                <Link to={Helpers.config.convertUrl({ url: '/noti-historico' })}>
                    <button type="button" style={btnPrimary}>
                        <i className="fa fa-arrow-left" />Regresar
                    </button>
                </Link>
            </>}
        </ReactPlaceholder>
    )
}

export default NotiBlog
